import { updates } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
            最新动态
          </h2>
          <p className="text-sm text-foreground-600">每日大赛最新快讯，赛事动态一手掌握</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200 hidden sm:block"></div>

          <div className="space-y-2">
            {updates.map((item) => (
              <a
                key={item.id}
                href="#cards"
                className="flex items-start gap-4 p-3 md:p-4 rounded-xl hover:bg-background-100 transition-colors cursor-pointer group"
              >
                <div className="relative flex-shrink-0 mt-0.5 hidden sm:block">
                  <span className="w-2.5 h-2.5 rounded-full bg-primary-500 block relative z-10"></span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {item.category}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors leading-relaxed">
                    {item.title}
                  </h3>
                </div>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-hover:text-primary-500 transition-colors">
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}